<nb-card
  [status]="purchase.isCancel ? 'danger' : 'basic'"
  [nbSpinner]="loading"
  nbSpinnerStatus="info"
>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="content" (click)="loadContent()">
          <div>
            <nb-icon icon="calendar-outline"></nb-icon>
            <span class="link text-hint">
              {{ purchase.issueDate | date: "dd/MM/yyyy HH:mm" }}</span
            >
          </div>

          <div class="supplier-info">
            <h6 class="link text-body">
              {{ purchase.supplierName }}
              <span *ngIf="purchase.supplierMobile" class="link text-hint">
                - {{ purchase.supplierMobile }}
              </span>
            </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <a (click)="loadContent()" class="link">
        <h5 class="text-primary">{{ purchase.totalAmount | number }}</h5>
      </a>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="isMore">
    <div class="content">
      <div class="table-responsive">
        <table class="purchase-detail table table-striped">
          <thead class="thead-light">
            <tr>
              <th scope="col">#</th>
              <th scope="col">{{ "product.name" | translate }}</th>
              <th scope="col">{{ "product.unit" | translate }}</th>
              <th scope="col" class="col-number">
                {{ "common.unitPrice" | translate }}
              </th>
              <th scope="col" class="col-number">
                {{ "common.quantityShort" | translate }}
              </th>
              <th scope="col" class="col-number">
                {{ "common.discountAmount" | translate }}
              </th>
              <th scope="col" class="col-number">
                {{ "common.totalAmount" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of purchase.purchaseDetails; let i = index">
              <td class="col-no">
                {{ i + 1 }}
              </td>
              <td>
                {{ item.productName }}
              </td>
              <td>
                {{ item.productUnitName }}
              </td>
              <td class="col-number">
                {{ item.price | number }}
              </td>
              <td class="col-number">
                {{ item.quantity | number }}
              </td>
              <td class="col-number">
                {{ item.discountAmount | number }}
              </td>
              <td class="col-number">
                <strong>{{ item.amount | number }}</strong>
              </td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td class="col-label" colspan="4">
                <strong class="text-hint">TỔNG CỘNG</strong>
              </td>
              <td class="col-number">
                <strong class="text-primary">
                  {{ purchase.totalQuantity | number }}
                </strong>
              </td>
              <td></td>
              <td class="col-number">
                <strong class="text-primary">
                  {{ purchase.detailAmount | number }}
                </strong>
              </td>
            </tr>
            <tr *ngIf="purchase.supplierAddress">
              <td colspan="7">
                <label class="text-hint"
                  >{{ "common.address" | translate }}:</label
                >
                <span class="description">
                  {{ purchase.supplierAddress }}
                </span>
              </td>
            </tr>
            <tr *ngIf="purchase.note">
              <td colspan="7">
                <label class="text-hint"
                  >{{ "common.note" | translate }}:</label
                >
                <span class="description"> {{ purchase.note }} </span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="purchase-info">
        <table class="table table-borderless">
          <tr>
            <td class="col-label">
              <label class="label">
                {{ "common.netAmount" | translate }}:</label
              >
            </td>
            <td class="col-number">
              <strong class="text-body">
                {{ purchase.detailNetAmount | number }}
              </strong>
            </td>
          </tr>

          <tr *ngIf="purchase.totalDiscountAmount > 0">
            <td class="col-label">
              <label class="label"
                >{{ "common.totalDiscountAmount" | translate }}:</label
              >
            </td>
            <td class="col-number">
              <span class="text-body">
                {{ purchase.totalDiscountAmount | number }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="col-label">
              <label class="label">
                {{ "common.totalAmount" | translate }}:</label
              >
            </td>
            <td class="col-number">
              <strong class="text-danger">
                {{ purchase.totalAmount | number }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="col-label">
              <label class="label">{{ "common.status" | translate }}:</label>
            </td>
            <td class="col-number">
              <strong
                class="text-success"
                [ngClass]="
                  purchase.isCancel
                    ? 'text-danger'
                    : purchase.isClosed
                    ? 'text-success'
                    : 'text-info'
                "
              >
                {{ purchase.status }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="col-label">
              <label class="label">{{ "common.cashier" | translate }}:</label>
            </td>
            <td class="col-number">
              <span class="text-body description">
                {{ purchase.author?.email }}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="detail">
      <a *ngIf="isMore" (click)="loadContent()" class="link text-link">
        <nb-icon icon="chevron-up-outline"></nb-icon>
      </a>

      <div class="button-action" *ngIf="mode !== 'report'">
        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit(purchase)"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>

        <button
          *ngIf="!purchase.isCancel"
          nbButton
          ghost
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="printPurchase(purchase)"
        >
          <nb-icon icon="printer-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
